// extracted by mini-css-extract-plugin
export default {"wrapper":"Input_wrapper__1Hm6T"};